import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { PositionModel } from '../models/position.model';
import { LastEducationDegreeModel } from '../models/last-education-degree.model';
import { InformWayModel } from '../models/inform-way.model';
import { HoldingTypeModel } from '../models/holding-types.model';
import { CourseModel } from '../models/course.model';
import { TeacherModel } from '../models/teacher.model';
import { NewsModel } from '../models/news.model';

@Injectable({
  providedIn: 'root',
})
export class BasicInformationService {
  apiUrl: string = environment.baseApi + 'basic-information/';

  constructor(private http: HttpClient) {}

  getPositions() {
    return this.http.get<PositionModel[]>(this.apiUrl + 'positions/');
  }

  getEducationDegrees() {
    return this.http.get<LastEducationDegreeModel[]>(
      this.apiUrl + 'education-degrees/',
    );
  }

  getInformWays() {
    return this.http.get<InformWayModel[]>(this.apiUrl + 'inform-ways/');
  }

  getHoldingTypeOptions() {
    return this.http.get<HoldingTypeModel[]>(this.apiUrl + 'holding-types/');
  }

  getCourseOptions() {
    return this.http.get<CourseModel[]>(this.apiUrl + 'courses/');
  }

  getTeacherOptions() {
    return this.http.get<TeacherModel[]>(this.apiUrl + 'teachers/');
  }

  getAfraNews() {
    return this.http.get<NewsModel[]>(environment.baseApi + 'news/');
  }
}
